export const getGoogleDriveEmbeddedFolderUrl = (driveFolderId: string) =>
  `https://drive.google.com/embeddedfolderview?id=${driveFolderId}#grid`;
